import { Divider, Typography } from "antd";
import React from "react";
import AddBulkScan from "../../../components/Comman/BulkInwardOutward/AddBulkScan";
import "../../../styles/global-ui.css";

const Wash_BulkInwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
             Washing Center Bin Bulk Inward
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan, review, and receive multiple bins into washing center
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <AddBulkScan
        title="Bin Bulk Inward"
        userData={userData}
        type="inward"
      />
    </div>
  );
};

export default Wash_BulkInwardPage;